// extracted by mini-css-extract-plugin
export var optionGrid = "_5f-7";
export var optionList = "_5f-6";
export var questionsBlock = "_5f-9";
export var spacer = "_5f-5";
export var stepCenteredContent = "_5f-3";
export var stepInner = "_5f-0";
export var stepInnerFullWidth = "_5f-1";
export var stepInnerLockScroll = "_5f-2";
export var stepTransitionFrame = "_5f-4";
export var welcomeBlock = "_5f-8";